import { z, ZodType } from 'zod';
import { EntityWithName, entityWithNameSchema } from './entity-with-name';

export const BET_STATUSES = {
	win: 'win',
	lose: 'lose',
} as const satisfies Record<string, string>;

export type BetStatus = (typeof BET_STATUSES)[keyof typeof BET_STATUSES];

export type BetReport = {
	id: string;
	account: EntityWithName;
	cashdesk: EntityWithName;
	game: EntityWithName;
	currency: string;
	date: string;
	wager: number;
	multiplier: number;
	status: BetStatus;
	winAmount: number;
};

export const betReportSchema: ZodType<BetReport> = z.object({
	id: z.string(),
	account: entityWithNameSchema,
	cashdesk: entityWithNameSchema,
	game: entityWithNameSchema,
	currency: z.string(),
	date: z.string(),
	wager: z.number(),
	multiplier: z.number(),
	status: z.nativeEnum(BET_STATUSES),
	winAmount: z.number(),
});

export type BetReportAdditionalData = {
	summary: {
		numberOfBets: number;
		currency?: string;
		wager?: number;
		winAmount?: number;
	};
};

export const betReportAdditionalDataSchema: ZodType<BetReportAdditionalData> = z.object({
	summary: z.object({
		numberOfBets: z.number(),
		currency: z.string().optional(),
		wager: z.number().optional(),
		winAmount: z.number().optional(),
	}),
});
